module.exports = __webpack_public_path__ + "media/images/avatar-admin-5623ad31efdae8c5b252d404d8e8e68b.svg";